import { defineStore } from 'pinia'

const message = {
  text: null,
  level: 'error'
}

export const useMessageStore = defineStore('message', {
  state: () => {
    return {
      message: { ...message }
    }
  },
  getters: {
    show() {
      return JSON.stringify(this.message) !== JSON.stringify(message)
    }
  },
  actions: {
    /**
     * Set the alert message
     *
     * @param {Object}<String text, String level> value The values to set to the alert
     * @returns {ThisParameterType} Return this for chaining
     */
    setAlert(value) {
      this.message = value
      return this
    },
    /**
     * Clear the alert message
     *
     * @param {VoidFunction}
     * @returns {ThisParameterType} Return this for chaining
     */
    clear() {
      this.message = { ...message }
      return this
    }
  }
})
